module.exports = __webpack_public_path__ + "static/media/drink.47a9a28c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/drink.svg
// module id = 1091
// module chunks = 0